import { Fab, Tooltip } from '@mui/material';
import FeedbackIcon from '@mui/icons-material/RateReview';

const FEEDBACK_FORM_URL =
  'https://form.asana.com/?k=rQFgxoYPs9syO7_rTcMv5w&d=1201382505479594';

export default function FeedbackFab() {
  return (
    <Tooltip title="Send us feedback" placement="left" arrow>
      <Fab
        color="secondary"
        size="medium"
        aria-label="Send feedback"
        component="a"
        href={FEEDBACK_FORM_URL}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          position: 'fixed',
          bottom: { xs: 72, sm: 80 },
          right: { xs: 16, sm: 24 },
          zIndex: 1050,
          boxShadow:
            '0px 4px 14px rgba(0,0,0,0.22), 0px 2px 6px rgba(0,0,0,0.10)',
          transition: 'transform 0.2s ease, box-shadow 0.2s ease',
          '&:hover': {
            transform: 'scale(1.08)',
            boxShadow:
              '0px 6px 20px rgba(0,0,0,0.28), 0px 3px 8px rgba(0,0,0,0.14)',
          },
        }}
      >
        <FeedbackIcon />
      </Fab>
    </Tooltip>
  );
}
